export const ACCESSIBILITY_RESOLUTION = 768;

export const ModalType = {
  DELETE: 'delete',
  MUTE: 'mute',
};

export const ABORT_TEST_STATUS_VALUES = [
  'Allocating VM',
  'Queued',
  'Running',
  'Pqueued',
];

export const DELETE_TEST_STATUS_VALUES = [
  'Passed',
  'Failed',
  'Completed',
  'Queue_timeout',
  'Idle_timeout',
  'Stopped',
  'Cancelled',
  'Timeout',
  'Error',
  'Lambda error',
];

export const JsonTheme = {
  LIGHT: 'rjv-default',
  DARK: 'tomorrow',
};

export const MAX_TEST_NAME_LENGTH = 255;
